// extracted by mini-css-extract-plugin
export default {"techCircle":"TechSkill_techCircle__pd4g1","techIcon":"TechSkill_techIcon__cQFfM","tooltip":"TechSkill_tooltip__WyAhN"};